<template>
  <div class="h-full">
    <div id="pointSearch" class="h-full">
      <el-row :gutter="15" class="h-full">
        <el-col :span="12" class="h-full">
          <el-card
            :body-style="{ padding: '20px', height: '100%' }"
            class="h-full"
            v-loading="actualLoading"
          >
            <div class="clearfix pb-18px pr-20px">
              <span class="text-label border-l-3 border-color-primary flex-1 pl-10px text-18px">{{
                $t('实时数据查询')
              }}</span>
            </div>
            <el-row>
              <selectStandardId @updateStandardId="updateStandardId" />
              <el-input
                :placeholder="$t('测点编码或中文名称')"
                v-model="actualSearch.keyword"
                clearable
                size="small"
                class="w-200px ml-10px mr-10px"
              ></el-input>
              <!-- {{ currentEnv }} -->
              <el-select
                v-model="actualSearch.plantUnit"
                filterable
                clearable
                :placeholder="$t('机组')"
                class="w-100px mr-10px"
                size="small"
                v-if="!Object.prototype.hasOwnProperty.call(currentEnv, 'machineGroup')"
              >
                <el-option
                  v-for="(item, index) in plantUnitData"
                  :key="index"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
              <el-select
                v-model="actualSearch.plantUnit"
                filterable
                clearable
                :placeholder="$t('机组')"
                class="w-100px mr-10px"
                size="mini"
                v-else-if="!currentEnv.machineGroup.isMachineGroup"
              >
                <el-option
                  v-for="(item, index) in plantUnitData"
                  :key="index"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
              <el-select
                v-model="actualSearch.plantUnit"
                filterable
                clearable
                :placeholder="currentEnv.machineGroup.alias"
                class="w-200px mr-10px"
                size="mini"
                v-else
              >
                <el-option
                  v-for="(item, index) in plantUnitData"
                  :key="index"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
              <el-select
                v-model="actualSearch.pointType"
                filterable
                clearable
                :placeholder="$t('测点类型')"
                class="w-200px mr-10px"
                size="small"
              >
                <el-option
                  v-for="(item, index) in pointType"
                  :key="index"
                  :label="item.name"
                  :value="item.seq"
                ></el-option>
              </el-select>
              <el-button type="primary" @click="searchActualData" class="mr-10px">{{
                $t('search')
              }}</el-button>
              <el-button
                :disabled="!$hasAccess('export')"
                @click="exportActual"
                class="mt-10px !ml-0px"
                >{{ $t('export') }}</el-button
              >
            </el-row>
            <el-table
              :data="actualPointData"
              class="mt-20px table-row-click"
              height="calc(100% - 190px)"
              :key="tableKey"
              border
              stripe
              @row-click="rowClick"
              highlight-current-row
            >
              <el-table-column :label="$t('序号')" type="index" width="50"> </el-table-column>
              <el-table-column
                :label="$t('测点编码')"
                prop="code"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                :label="$t('中文名称')"
                prop="name"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                :label="$t('机组')"
                prop="plantUnitId"
                :formatter="filterPlantUnitId"
                width="80"
                show-overflow-tooltip
                v-if="!Object.prototype.hasOwnProperty.call(currentEnv, 'machineGroup')"
              ></el-table-column>
              <el-table-column
                :label="$t('机组')"
                prop="plantUnitId"
                :formatter="filterPlantUnitId"
                width="80"
                show-overflow-tooltip
                v-else-if="!currentEnv.machineGroup.isMachineGroup"
              ></el-table-column>
              <el-table-column
                :label="currentEnv.machineGroup.alias"
                prop="plantUnitId"
                :formatter="filterPlantUnitId"
                width="80"
                show-overflow-tooltip
                v-else
              ></el-table-column>
              <el-table-column
                :label="$t('测点类型')"
                prop="type"
                :formatter="filterType"
                width="80"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                :label="$t('实时值')"
                prop="actualValue"
                width="80"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column :label="$t('单位')" prop="unit" width="60"></el-table-column>
              <el-table-column
                :label="$t('时间')"
                prop="time"
                show-overflow-tooltip
              ></el-table-column>
            </el-table>
            <el-pagination
              class="mt-20px float-right"
              background
              @size-change="searchActualData"
              @current-change="findAcutalData(page1)"
              :current-page.sync="page1.pageNo"
              :page-size.sync="page1.pageSize"
              :page-sizes="$pageSizeAll"
              layout="total, sizes, prev, pager, next"
              :total="total1"
              :pager-count="5"
            ></el-pagination>
          </el-card>
        </el-col>
        <el-col :span="12" class="h-full">
          <el-card
            :body-style="{ padding: '20px', height: '100%' }"
            class="h-full"
            v-loading="historyLoading"
          >
            <div class="clearfix pb-18px pr-20px">
              <span class="text-label border-l-3 border-color-primary flex-1 pl-10px text-18px">{{
                $t('历史数据查询')
              }}</span>
            </div>
            <el-row :gutter="10">
              <el-col :lg="6" :xl="6">
                <el-tooltip
                  placement="top"
                  :content="historySearch.keyword"
                  v-if="historySearch.keyword"
                >
                  <el-input
                    v-model="historySearch.keyword"
                    :placeholder="$t('测点编码')"
                    clearable
                    size="small"
                    disabled
                  >
                    <el-button
                      slot="append"
                      class="iconfont icon-line-seach"
                      @click="openPointsDialog"
                    ></el-button
                  ></el-input>
                </el-tooltip>
                <el-input
                  v-model="historySearch.keyword"
                  :placeholder="$t('测点编码')"
                  clearable
                  size="small"
                  disabled
                  v-else
                >
                  <el-button
                    slot="append"
                    class="iconfont icon-line-seach"
                    @click="openPointsDialog"
                  ></el-button
                ></el-input>
              </el-col>
              <el-col :lg="10" :xl="12">
                <!-- type="datetimerange" -->
                <!-- popper-class="point-search-date-picker" -->
                <el-date-picker
                  v-model="historySearch.time"
                  type="datetimerange"
                  range-separator="至"
                  start-placeholde="开始时间"
                  end-placeholde="结束时间"
                  style="width: 100%"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  size="small"
                  @change="handleTime"
                  :picker-options="pickerOptions"
                  :clearable="false"
                ></el-date-picker>
              </el-col>
              <el-col :lg="8" :xl="5" class="fz-12 flex">
                <span class="mr-5px w-80px" style="line-height: 36px">{{ $t('颗粒度') }}</span>
                <el-select
                  filterable
                  clearable
                  v-model="historySearch.interval"
                  style="width: calc(100% - 45px)"
                  size="small"
                >
                  <el-option
                    v-for="(item, index) in intervalData"
                    :key="index"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-col>
              <el-col :lg="24" :xl="24" class="mt-10px">
                <el-button type="primary" @click="searchHistoryData">{{ $t('search') }}</el-button>
                <el-button
                  type="primary"
                  :disabled="!$hasAccess('read')"
                  @click="openTrendDialog"
                  >{{ $t('趋势曲线') }}</el-button
                >
                <el-button :disabled="!$hasAccess('export')" @click="exportHistory">{{
                  $t('export')
                }}</el-button>
              </el-col>
            </el-row>
            <el-table
              :data="historyPointData"
              class="mt-20px"
              height="calc(100% - 190px)"
              border
              stripe
            >
              <el-table-column :label="$t('序号')" type="index" width="50"> </el-table-column>
              <el-table-column
                :label="$t('测点编码')"
                prop="code"
                show-overflow-tooltip
              ></el-table-column>
              <!-- <el-table-column label="中文名称" prop="name"
                show-overflow-tooltip></el-table-column> -->
              <el-table-column
                :label="$t('数值')"
                prop="value"
                width="80"
                show-overflow-tooltip
              ></el-table-column>
              <!-- <el-table-column label="单位" prop="unit" width="120"></el-table-column> -->
              <el-table-column
                :label="$t('时间')"
                prop="time"
                show-overflow-tooltip
              ></el-table-column>
            </el-table>
            <el-pagination
              class="mt-20px float-right"
              background
              @size-change="getHistoryData(tagsId, 'size')"
              @current-change="getHistoryData(tagsId)"
              :current-page.sync="page2.pageNo"
              :page-size.sync="page2.pageSize"
              :page-sizes="$pageSizeAll"
              layout="total, sizes, prev, pager, next"
              :total="total2"
              :pager-count="5"
            ></el-pagination>
          </el-card>
        </el-col>
      </el-row>
      <el-dialog
        :close-on-click-modal="false"
        :title="$t('测点')"
        :visible.sync="pointsDialog"
        class="small-dialog"
        @close="closeDialog"
        v-dialogDrag
      >
        <div class="mb-10px">
          <el-input
            v-model="pointName"
            clearable
            :placeholder="$t('测点编码或测点名称')"
            style="width: 200px"
          ></el-input>
          <el-button
            type="primary"
            icon="iconfont icon-search"
            size="small"
            class="ml-10px"
            @click="searchPointData"
            >{{ $t('search') }}</el-button
          >
        </div>
        <el-table :data="pointData" height="385px" border stripe @current-change="currentChange">
          <el-table-column width="50" align="center">
            <template slot-scope="scope">
              <el-radio v-model="pointRadio" :label="scope.row.code">&nbsp;</el-radio>
            </template>
          </el-table-column>
          <el-table-column :label="$t('测点编码')" prop="code"></el-table-column>
          <el-table-column :label="$t('测点名称')" prop="name"></el-table-column>
          <el-table-column :label="$t('单位')" prop="unit"></el-table-column>
        </el-table>
        <el-pagination
          class="mt-10px tr"
          background
          @size-change="searchPointData"
          @current-change="findPointData(page3)"
          :current-page.sync="page3.pageNo"
          :page-size.sync="page3.pageSize"
          :page-sizes="[5, 10, 20, 30, 50]"
          layout="->, total, sizes, prev, pager, next"
          :total="total3"
          :pager-count="5"
        ></el-pagination>
        <div class="mt-10px">
          <el-row type="flex" justify="center" class="mt-5px">
            <el-button type="primary" size="medium" class="iconfont icon-save" @click="savePoint">{{
              $t('save')
            }}</el-button>
            <el-button size="medium" class="iconfont icon-close" @click="pointsDialog = false">{{
              $t('cancel')
            }}</el-button>
          </el-row>
        </div>
      </el-dialog>
      <trend-view ref="trendView" :standardId="standardId"></trend-view>
    </div>
  </div>
</template>
<script type="text/babel">
import FnMixins from '@/assets/js/fnMixins'
import alarmService from '@/services/AlarmManagement'
import TargetManagementService from '@/services/DatatargetManagement'
import TrendView from '@/modules/resource/components/trendView'
import selectStandardId from '../../components/selectStandardId'

export default {
  name: 'pointSearch',
  components: {
    TrendView,
    selectStandardId,
  },
  mixins: [FnMixins],
  data() {
    return {
      pickerOptions: {
        disabledDate(time) {
          // return time.getTime() > Date.now() - 8.64e6
          return time > new Date()
        },
      },
      tableKey: 52346,
      plantUnitData: [],
      pointType: [
        {
          name: '模拟量',
          seq: 1,
          value: 'AI',
        },
        {
          name: '开关量',
          seq: 2,
          value: 'DI',
        },
      ],
      actualSearch: {
        keyword: '',
        plantUnit: '',
      },
      actualPointData: [],
      total1: 0,
      page1: {
        pageNo: 1,
        pageSize: 15,
      },
      historySearch: {
        keyword: '',
        time: [],
        interval: '0',
      },
      intervalData: [
        {
          label: '秒',
          value: '0',
        },
        {
          label: '分钟',
          value: '1',
        },
        {
          label: '小时',
          value: '2',
        },
        {
          label: '天',
          value: '3',
        },
        // {
        //   label: '周',
        //   value: '4',
        // },
      ],
      historyPointData: [],
      page2: {
        pageNo: 1,
        pageSize: 15,
      },
      total2: 0,
      actualLoading: false,
      pointsDialog: false,
      pointData: [],
      page3: {
        pageNo: 1,
        pageSize: 5,
      },
      total3: 0,
      pointName: '',
      pointRadio: '',
      historyLoading: false,
      tagsId: '',
      historySearchSlag: 0,
      //  标准部分
      standardId: localStorage.getItem('standardId'),
      codeName: '',
      currentEnv: Wiz.GetModuleConfig('legacy-resource').currentEnv,
    }
  },
  computed: {
    currentProject() {
      return this.$store.getters['Sites/currentProject'] || {}
    },
    searchTime() {
      return this.historySearch.time
    },
  },
  watch: {
    searchTime(val) {
      if (val && val.length && moment(val[1]).unix() - moment(val[0]).unix() > 86400) {
        this.intervalData = [
          {
            label: '分钟',
            value: '1',
          },
          {
            label: '小时',
            value: '2',
          },
          {
            label: '天',
            value: '3',
          },
          // {
          //   label: '周',
          //   value: '4',
          // },
        ]
        if (
          this.historySearch.interval === '0' &&
          moment(val[1]).unix() - moment(val[0]).unix() <= 2592000
        ) {
          this.historySearch.interval = '1'
          this.$message.warning('秒级颗粒度最大选择区间为一天!')
        }
      } else {
        this.intervalData = [
          {
            label: '秒',
            value: '0',
          },
          {
            label: '分钟',
            value: '1',
          },
          {
            label: '小时',
            value: '2',
          },
          {
            label: '天',
            value: '3',
          },
          // {
          //   label: '周',
          //   value: '4',
          // },
        ]
      }
    },
    standardId(newVal) {
      if (newVal) {
        this.searchActualData()
      }
    },
  },
  methods: {
    updateStandardId(val) {
      this.standardId = val
    },
    handleTime(time) {
      if (time && time.length && moment(time[1]).unix() - moment(time[0]).unix() > 2592000) {
        this.historySearch.time = []
        this.$message.warning('最大选择区间为30天!')
      }
    },
    searchHistoryData() {
      this.historySearchSlag = 1
      this.page2.pageNo = 1
      this.findHistoryData()
    },
    searchPointData() {
      this.page3.pageNo = 1
      this.findPointData(this.page3)
    },
    searchActualData() {
      this.historySearchSlag = 0
      this.page1.pageNo = 1
      this.findAcutalData(this.page1)
    },
    // 适配机组名称
    filterPlantUnitId(row, column, cellValue) {
      if (!_.isEmpty(this.plantUnitData)) {
        let str = ''
        _.forEach(this.plantUnitData, (item) => {
          if (item.id === cellValue) str = item.name
        })
        return str
      }
      return ''
    },
    // 适配测点类型
    filterType(row, column, cellValue) {
      if (!_.isEmpty(this.pointType)) {
        let str = ''
        _.forEach(this.pointType, (item) => {
          if (item.seq === cellValue) str = item.name
        })
        return str
      }
      return ''
    },
    // 获取机组数据
    async getPlantUnit() {
      const res = await alarmService.getGroupData()
      if (res && res.code === 0 && !_.isNil(res.data)) {
        this.plantUnitData = res.data
      }
    },
    // 获取实时数据
    async getActualData(tagsId) {
      const currentTime = (moment().valueOf() / 1000).toFixed()
      const res = await alarmService.getRealTimeCurve({
        startTime: currentTime,
        endtime: currentTime,
        // data_store_type: 0,
        // app_id: 1, // 暂定
        // factory_id: this.currentProject.factoryId,
        // group_id: this.currentProject.groupId,
        pointIds: tagsId,
      })
      if (res && res.code === 0 && !_.isEmpty(res.data)) {
        return res.data
      }
      return []
    },
    // 获取实时列表数据
    async findAcutalData(page = { pageNo: 1, pageSize: 10 }) {
      this.actualLoading = true
      const params = {
        SkipCount: page.pageNo,
        MaxResultCount: page.pageSize,
        StandardId: this.standardId, // 标准id
        SearchText: this.actualSearch.keyword, // 测点编码
        PlantUnitId: this.actualSearch.plantUnit, // 机组
      }
      if (
        this.actualSearch.pointType &&
        this.actualSearch.pointType !== '' &&
        this.actualSearch.pointType !== null
      ) {
        params.Type = this.actualSearch.pointType // 测点类型
      }
      const res = await TargetManagementService.getTargetList(params)
      if (res && res.code === 0 && !_.isNil(res.data)) {
        this.actualPointData = res.data
        this.total1 = res.totalCount
        const pointsArr = _.map(res.data, (o) => {
          return o.pointId
        })
        if (pointsArr.length > 0) {
          const actualData = await this.getActualData(pointsArr)
          if (actualData.length > 0) {
            this.actualPointData = _.map(res.data, (o) => {
              const actual = _.find(actualData, { pointId: o.pointId })
              o.actualValue = actual ? actual.pointValues[0].value : ''
              o.time = actual
                ? moment(actual.pointValues[0].timeValue * 1000).format('YYYY-MM-DD HH:mm:ss')
                : ''
              return o
            })
            this.tableKey += 1
          }
        }
      }
      this.actualLoading = false
    },
    // 导出实时数据
    async exportActual() {
      const currentTime = (moment().valueOf() / 1000).toFixed()
      const params = {
        startTime: currentTime,
        endTime: currentTime,
        // dataStoreType: 0,
        // app_id: 1, // 暂定
        // factory_id: this.currentProject.factoryId,
        // group_id: this.currentProject.groupId,
        plantUnitId: this.actualSearch.plantUnit,
        type: this.actualSearch.pointType,
        keyword: this.actualSearch.keyword,
        // pagesize: 1000000000,
        standardId: this.standardId,
      }
      const res = await alarmService.exportRealTime(params)
      if (res) {
        const time = FnMixins.methods.getNowTime()
        FnMixins.methods.downLoadExcel(`实时数据${time}`, res)
      }
    },
    // 计算interval
    computedInterval() {
      const type = this.historySearch.interval
      let interval = 1
      if (type === '0') {
        interval = 1
      } else if (type === '1') {
        interval = 60
      } else if (type === '2') {
        interval = 60 * 60
      } else if (type === '3') {
        interval = 60 * 60 * 24
      } else if (type === '4') {
        interval = 60 * 60 * 24 * 7
      }
      return interval
    },
    // 获取历史数据
    async getHistoryData(tagId, type) {
      if (type === 'size') this.page2.pageNo = 1
      const interval = this.computedInterval()
      const startTime =
        this.historySearch.time.length > 0 && this.historySearch.time[0] !== 'Invalid date'
          ? (moment(this.historySearch.time[0]).valueOf() / 1000).toFixed()
          : (moment().valueOf() / 1000).toFixed()
      const endTime =
        this.historySearch.time.length > 0 && this.historySearch.time[1] !== 'Invalid date'
          ? (moment(this.historySearch.time[1]).valueOf() / 1000).toFixed()
          : (moment().valueOf() / 1000).toFixed()
      const res = await alarmService.getHistoryPointData({
        startTime,
        endTime,
        interval,
        // app_id: 1, // 暂定
        // factory_id: this.currentProject.factoryId,
        // group_id: this.currentProject.groupId,
        pointIds: [tagId],
        pageNo: this.page2.pageNo,
        pageSize: this.page2.pageSize,
        sort: 0,
      })
      if (res && res.code === 0 && !_.isEmpty(res.data)) {
        this.total2 = res.totalCount === -1 ? 0 : res.totalCount
        if (res.data.length > 0) {
          if (type === 'pointId') {
            this.historyPointData = _.map(res.data[0].pointValues, (o) => {
              o.time = moment(o.timeValue * 1000).format('YYYY-MM-DD HH:mm:ss')
              o.code = this.codeName
              return o
            })
          } else {
            const data = this.historyPointData[0]
            this.historyPointData = _.map(res.data[0].pointValues, (o) => {
              o.time = moment(o.timeValue * 1000).format('YYYY-MM-DD HH:mm:ss')
              o.code = data.code
              o.name = data.name
              o.unit = data.unit
              return o
            })
          }
        } else {
          this.historyPointData = []
          this.total2 = 0
        }
      } else {
        this.historyPointData = []
        this.total2 = 0
      }
    },
    // 获取历史列表数据
    async findHistoryData(val) {
      if (val === 'pointId') {
        this.getHistoryData(this.tagsId, 'pointId')
      } else {
        if (!_.trim(this.historySearch.keyword)) return this.$message.warning('请选择测点!')
        if (!this.historySearch.time) this.historySearch.time = []
        if (this.historySearch.time.length === 0) {
          return this.$message.warning('请选择开始时间和结束时间!')
        }
        const startTime = moment(this.historySearch.time[0])
        const endTime = moment(this.historySearch.time[1])
        const type = this.historySearch.interval
        const message = '当前选择时间与颗粒度不符'
        if (
          (type === '0' && endTime.diff(startTime, 'seconds') < 1) ||
          (type === '1' && endTime.diff(startTime, 'minutes') < 1) ||
          (type === '2' && endTime.diff(startTime, 'hours') < 1) ||
          (type === '3' && endTime.diff(startTime, 'days') < 1) ||
          (type === '4' && endTime.diff(startTime, 'weeks') < 1)
        ) {
          return this.$message.warning(message)
        }
        this.historyLoading = true
        const res = await TargetManagementService.getTargetList({
          SkipCount: this.page2.pageNo,
          MaxResultCount: this.page2.pageSize,
          StandardId: this.standardId, // 标准id
          SearchText: this.historySearch.keyword,
          // point_id: this.tagsId,
        })
        if (res && res.code === 0 && !_.isNil(res.data) && res.data.length > 0) {
          const pointsArr = _.map(res.data, (o) => {
            return o.pointId
          })
          if (pointsArr.length > 0) {
            this.historyPointData = res.data
            this.total2 = res.totalCount
            // this.tagsId = pointsArr.join(',')
            await this.getHistoryData(this.tagsId)
          } else {
            this.total2 = 0
            this.historyPointData = []
          }
        }
        this.historyLoading = false
      }
      return true
    },
    // 实时列表点击
    rowClick(row) {
      this.historySearch.keyword = row.code
      // 增加京隆磨煤机专用逻辑
      if (this.currentEnv.VUE_APP_PROJECT === 'JL' && _.isEmpty(this.historySearch.time)) {
        this.historySearch.time = [
          moment(row.time)
            .subtract(1, 'hours')
            .format('YYYY-MM-DD HH:mm:ss'),
          row.time,
        ]
        this.historySearch.interval = '0'
      } else if (this.currentEnv.VUE_APP_PROJECT !== 'JL') {
        this.historySearch.time = row.time
          ? [
              moment(row.time)
                .subtract(1, 'hours')
                .format('YYYY-MM-DD HH:mm:ss'),
              row.time,
            ]
          : []
        this.historySearch.interval = '0'
      }
      this.tagsId = row.pointId
      this.codeName = row.code
      this.findHistoryData('pointId')
    },
    // 导出历史数据
    async exportHistory() {
      const interval = this.computedInterval()
      if (this.historyPointData.length === 0) {
        this.$message.warning('请先搜索测点历史数据!')
        return
      }
      const params = {
        startTime: (moment(this.historySearch.time[0]).valueOf() / 1000).toFixed(),
        endTime: (moment(this.historySearch.time[1]).valueOf() / 1000).toFixed(),
        interval,
        // factory_id: this.currentProject.factoryId,
        // group_id: this.currentProject.groupId,
        keyword: this.historySearch.keyword,
        // pagesize: 1000000000,
        // app_id: 1,
        standardId: this.standardId,
      }
      const res = await alarmService.exportHistory(params)
      if (res) {
        const time = FnMixins.methods.getNowTime()
        FnMixins.methods.downLoadExcel(`历史数据${time}`, res)
      }
    },
    // 打开趋势曲线对话框
    async openTrendDialog() {
      if (this.historySearch.time.length === 0) {
        this.$message.warning('请选择开始时间和结束时间!')
        return
      }
      if (this.historyPointData.length === 0) {
        this.$message.warning('请先搜索测点历史数据!')
        return
      }
      this.$refs.trendView.search.status = 1
      // this.$refs.trendView.search.time = _.cloneDeep(this.historySearch.time)
      this.$refs.trendView.search.interval = 1
      this.$refs.trendView.search.date = Number(this.historySearch.interval)
      this.$refs.trendView.trendTableData = []
      this.$refs.trendView.addPoint(this.tagsId)
      this.$refs.trendView.trendDialog = true
    },
    // 获取测点数据
    async findPointData(page = { pageSize: 5, pageNo: 1 }) {
      const res = await TargetManagementService.getTargetList({
        SkipCount: page.pageNo,
        MaxResultCount: page.pageSize,
        StandardId: this.standardId,
        // name: {
        //   $text: this.pointName,
        // },
        SearchText: this.pointName,
      })
      if (res && res.code === 0 && !_.isNil(res.data)) {
        this.pointData = res.data
        this.total3 = res.totalCount
      }
    },
    // 打开测点对话框
    async openPointsDialog() {
      this.page3.pageNo = 1
      this.page3.pageSize = 5
      await this.findPointData()
      this.pointsDialog = true
    },
    currentChange(val) {
      if (val) {
        this.pointRadio = val.code
      }
    },
    closeDialog() {
      this.pointName = ''
    },
    savePoint() {
      this.historySearch.keyword = this.pointRadio
      this.pointsDialog = false
      const point = _.find(this.pointData, { code: this.pointRadio })
      this.tagsId = point.pointId
    },
  },
  beforeCreate() {},
  async created() {
    await this.getPlantUnit()
    if (this.standardId) {
      this.searchActualData()
    }
  },
  activated() {
    this.standardId = localStorage.getItem('standardId')
  },
  beforeMount() {},
  mounted() {
    window.onresize = () => {
      this.$nextTick(() => {
        if (document.getElementById('echarts')) {
          const echart1 = this.$echarts.init(document.getElementById('echarts'), 'macarons')
          echart1.resize()
          this.initEchart()
        }
      })
    }
  },
  beforeUpdate() {},
  updated() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {},
  destroyed() {},
}
</script>
<style lang="scss" rel="stylesheet/scss" type="text/scss" scope>

#pointSearch {
  .el-range-separator {
    width: 20px;
  }
  .search_dialog {
    @media screen and (max-height: 625px) {
      /deep/ .el-dialog {
        margin-top: 1vh !important;
      }
    }
  }
}
.point-search-date-picker {
  .el-time-panel.el-popper {
    width: 156px !important;
  }
}

</style>
